import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

const BRIGHTNESS_MIN = -0.4;
const BRIGHTNESS_MAX = 0.4;

interface BaseItemBrightnessOptionProps {
  brightness: number;
  updateBrightness(brightness: number, undoable?: boolean): void;
}

export function BaseItemBrightnessOption({...props}: BaseItemBrightnessOptionProps): ReactElement<any> {
  const onChangeHandler = (updatedValue: number): void => {
    props.updateBrightness(updatedValue, false);
  };

  const onChangeEndedHandler = (updatedValue: number): void => {
    props.updateBrightness(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      id="item-brightness-option"
      value={props.brightness}
      label={window.i18next.t('pmwjs_brightness')}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEndedHandler}
      range={{min: BRIGHTNESS_MIN, max: BRIGHTNESS_MAX}}
      transformDisplay={{min: 0, max: 100}}
    />
  );
}
